import React,  { useState } from 'react';


export default function SmarterQuestions({showModal}) {

    return (
        <></>
    )
}